import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SlateViewChip from 'components/Shared/SlateViewChip';
import { slateViewsTypes } from 'config/constants';
import './style.css';

const SlateViewsList = ({ type, views, onSlateViewClick, compact = false }) => {
  const { t } = useTranslation();
  const isListType = type === slateViewsTypes.LIST;

  return (
    <div className={compact ? 'slate-view-list-compact' : 'slate-view-list'}>
      <div className={compact ? 'slate-view-list-title-compact' : 'slate-view-list-title'}>
        <i className={'material-symbols-outlined slate-view-list-title-icon' + (isListType ? ' slate-view-list-title-icon--list' : ' slate-view-list-title-icon--map')}>
          {isListType ? 'list' : 'location_on'}
        </i>
        {t('slateView:views', {
          type: isListType ? 'List' : 'Map',
        })}
      </div>

      <div className={compact ? 'slate-view-list-container-compact' : 'slate-view-list-container'}>
        {views.map((item) => (
          <div className={compact ? 'slate-view-list-item-compact' : 'slate-view-list-item'} key={item.uuid}>
            <button className="slate-view-list-item-btn" onClick={() => onSlateViewClick(item.uuid)}>
              <div className="slate-view-list-item-button">
                <div className={compact ? 'slate-view-list-item-name-compact' : 'slate-view-list-item-name'}>{item.name}</div>
                {item.listViewType && (
                  <SlateViewChip type={item.listViewType} count={item.count} />
                )}
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

SlateViewsList.propTypes = {
  type: PropTypes.string.isRequired,
  views: PropTypes.array.isRequired,
  onSlateViewClick: PropTypes.func.isRequired,
  compact: PropTypes.bool,
};

export default SlateViewsList;
